export default "__VITE_ASSET__DdInmZ30__"